import { styled } from '@mui/material/styles';
import classNames from 'classnames';
import { Fragment } from 'react';

import Link from '@mui/material/Link';
import Typography from '@mui/material/Typography';

import { faChevronRight } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const PREFIX = 'Breadcrumbs';

const classes = {
  root: `${PREFIX}-root`,
  breadcrumb: `${PREFIX}-breadcrumb`,
  breadcrumb_link: `${PREFIX}-breadcrumb_link`,
};

const Root = styled('div')(({ theme: { palette, spacing } }) => ({
  [`&.${classes.root}`]: {
    color: palette.text.secondary,
    '& > span': { userSelect: 'none' },
  },

  [`& .${classes.breadcrumb}`]: { padding: spacing(0, 0.5) },

  [`& .${classes.breadcrumb_link}`]: {
    '&:hover': { color: palette.text.primary },
  },
}));

export default function Breadcrumbs(props) {
  const { active, className, disabled, items, onChange } = props;

  function renderBreadcrumb(label, idx) {
    const commonProps = { children: label, variant: 'overline' };

    const breadcrumb =
      disabled || idx >= active ?
        <Typography
          {...commonProps} // eslint-disable-line @eslint-react/jsx-no-children-prop
          className={classes.breadcrumb}
          sx={{ color: active === idx ? 'text.primary' : 'text.secondary' }}
        />
      : <Link
          {...commonProps} // eslint-disable-line @eslint-react/jsx-no-children-prop
          className={classNames(classes.breadcrumb, classes.breadcrumb_link)}
          component="button"
          onClick={() => onChange(idx)}
          sx={{ color: 'text.secondary' }}
          underline="none"
        />;

    return (
      <Fragment key={label}>
        {Boolean(idx) && <FontAwesomeIcon fixedWidth icon={faChevronRight} size="xs" />}
        {breadcrumb}
      </Fragment>
    );
  }

  return <Root className={classNames(classes.root, className)}>{items.map(renderBreadcrumb)}</Root>;
}
